import { render, staticRenderFns } from "./DocumentProcessingCount.vue?vue&type=template&id=5854d6ba"
import script from "./DocumentProcessingCount.vue?vue&type=script&lang=ts"
export * from "./DocumentProcessingCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports